<template>
    <div id="map"></div>
</template>

<script>
import gmapsInit from "../gmaps";

export default {
    name: "GoogleMapLoader",

    props: {
        shop: Object
    },

    data() {
        return {
            map: null,
            google: null,
            marker: null,
            timer: null
        };
    },

    async mounted() {
        this.google = await gmapsInit();
        this.renderMap();
    },

    watch: {
        "shop.provincia": function (val, oldVal) {
            this.updateCoordinates();
        },
        "shop.citta": function (val, oldVal) {
            this.updateCoordinates();
        },
        "shop.cap": function (val, oldVal) {
            this.updateCoordinates();
        },
        "shop.indirizzo": function (val, oldVal) {
            this.updateCoordinates();
        },
        "shop.ragioneSociale": function (val, oldVal) {
            this.renderMap();
        }
    },

    methods: {
        updateCoordinates() {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.$api
                    .getCoordinatesFromAddress(this.shop)
                    .then((response) => {
                        console.debug("GET_COORDINATES_FROM_ADDRESS", response);
                        this.shop.coordinate.lat = response.coordinate.lat;
                        this.shop.coordinate.lng = response.coordinate.lng;
                        this.renderMap();
                    })
                    .catch((error) => {
                        console.error("GET_COORDINATES_FROM_ADDRESS", error);
                    });
            }, 1000);
        },

        renderMap() {
            var position = {
                lat: this.shop.coordinate.lat,
                lng: this.shop.coordinate.lng
            };

            this.map = new this.google.maps.Map(this.$el, {
                center: position,
                zoom: 16,
                maxZoom: 18,
                minZoom: 10,
                streetViewControl: false,
                disableDoubleClick: true
            });

            if (this.marker) {
                // rimuove listenere di marker precedentemente impostato
                this.google.maps.event.clearListeners(this.marker, "dragend");
                this.google.maps.event.clearListeners(this.marker, "click");
                // rimuove marker dalla mappa e lo rimuove anche del tutto
                this.marker.setMap(null);
                this.marker = null;
            }

            this.marker = new this.google.maps.Marker({
                position: position,
                map: this.map,
                title: this.shop.ragioneSociale,
                draggable: this.shop.isShop
            });

            this.marker.addListener("dragend", () => {
                this.shop.coordinate.lat = this.marker.getPosition().lat();
                this.shop.coordinate.lng = this.marker.getPosition().lng();
                this.renderMap();
            });

            const infowindow = new this.google.maps.InfoWindow({
                content: this.shop.ragioneSociale
            });
            this.marker.addListener("click", () => {
                infowindow.open(this.map, this.marker);
            });
        }
    }
};
</script>

<style>
#map {
    width: 50%;
    height: 50vh;
    margin: auto;
    margin-top: 1rem;
}
</style>
